let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("k47cc")).then(() => parcelRequire('lLBcI'));